import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { Reveal, LineReveal } from "@/components/Reveal";

const CAPITOL = "https://images.unsplash.com/photo-1557160854-e1e89fdd3286?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Policy() {
  const { policies, settings } = useContent();
  const s = settings || {};

  return (
    <div data-testid="policy-page">
      <section className="relative overflow-hidden border-b border-hairline/50 pt-40 pb-24 md:pt-52 md:pb-32">
        <img src={CAPITOL} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/70 to-navy" />
        <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="text-xs uppercase tracking-[0.32em] text-kinetic">Where We Stand</div>
          <h1 className="mt-6 max-w-4xl font-display text-6xl font-bold leading-[0.9] tracking-tighter text-bone md:text-8xl">
            <LineReveal text={"Policy\nStatements"} />
          </h1>
          <Reveal delay={0.4} className="mt-8 max-w-xl text-lg text-bone/70">
            <p>{s.policy_intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10">
        {policies.map((p, i) => (
          <Reveal key={p.id}>
            <article
              data-testid={`policy-item-${i}`}
              className="group grid gap-6 border-b border-hairline/50 py-14 md:grid-cols-[auto_1fr_1.4fr] md:gap-14 md:py-20"
            >
              <span className="font-display text-4xl italic text-hairline transition-colors duration-500 group-hover:text-kinetic md:text-5xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h2 className="font-display text-3xl font-bold tracking-tight text-bone md:text-4xl">{p.title}</h2>
                <p className="mt-4 text-base text-kinetic/90">{p.summary}</p>
              </div>
              <div>
                <p className="whitespace-pre-line text-lg leading-relaxed text-bone/70">{p.body}</p>
                {p.detail && p.detail.trim() && (
                  <Link
                    to={`/policy/${p.id}`}
                    data-testid={`policy-readmore-${i}`}
                    className="link-underline mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-widest text-kinetic"
                  >
                    Read more <ArrowRight size={15} />
                  </Link>
                )}
              </div>
            </article>
          </Reveal>
        ))}
        <div className="h-24" />
      </section>
    </div>
  );
}
